import { __localesModel, __localizedField } from "@/Utils/locales";
export const models = {
  locales: __localesModel,
  media: []
};
export const options = {
  typeOptions: []
};

export const Fields = [
  __localizedField,
  {
    type: "select",
    name: "type",
    label: "type",
    value: "",
    rules: "required",
    options: [],
    validationMessage: {
      required: "Select type please"
    },
    xl: "12"
  },
  {
    label: "Logo",
    name: "media",
    placeholder: "Choose image",
    type: "file",
    multiple: false,
    value: "",
    bodyClasses: "single-image",
    validationMessage: {
      required: "This field is required"
    },
    xl: "12"
  }
];
